
let windowRef = globalThis.window;

declare global {
  interface Window { 
    brightlyLegacyHosts: string[] | undefined;
    brightlyRedirectTarget: string | undefined;
  }
}

const setWindowRef = (ref: Window & typeof globalThis) => {
  windowRef = ref;
};

function performRedirect() {
  const baseUrl = windowRef.brightlyRedirectTarget ?? '';
  const legacyHosts = windowRef.brightlyLegacyHosts ?? [];
  
  if (!baseUrl || legacyHosts.length === 0) {
    return;
  }

  if (legacyHosts.includes(windowRef.location.host)) {
    const { pathname, search, hash } = windowRef.location;
    windowRef.location.replace(`${baseUrl}${pathname}${search}${hash}`);
  }
}

performRedirect();
export { setWindowRef, performRedirect };
